export default {
  path: '/refund_tasks',
  component: () => import('@/layouts/PublicLayout'),
  redirect: '/refund_tasks/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/refund_tasks/List'),
      meta: {
        title: '退款记录列表'
      }
    },
    {
      path: 'apply',
      component: () => import('@/views/refund_tasks/Apply'),
      meta: {
        title: '申请退款'
      }
    },
    {
      path: 'detail',
      component: () => import('@/views/refund_tasks/Detail'),
      meta: {
        title: '退款详情'
      }
    }
  ]
}
